import { c as _c } from "react/compiler-runtime";
import type { DocumentViewerCardContentReasonCode } from '@onefootprint/request-types/dashboard';
type ReasonCodeContentProps = {
  content: DocumentViewerCardContentReasonCode;
};
const ReasonCodeContent = t0 => {
  const $ = _c(2);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content.code) {
    t1 = <div className="py-2"><span className="text-caption-2 text-primary bg-senary px-2 py-1 rounded">{content.code}</span></div>;
    $[0] = content.code;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ReasonCodeContent;